import { render, staticRenderFns } from "./TiketType.vue?vue&type=template&id=1389f240&"
import script from "./TiketType.vue?vue&type=script&lang=js&"
export * from "./TiketType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports